import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdbreact";
import React, { useContext, useState, useEffect, useRef } from "react";
import { UserContext } from "../UserContext";

function UpdateHours() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);

  const activityIdRef = useRef(null);
  const emailId = useRef(null);
  const hours = useRef(null);
  const [loading, setLoading] = useState(true);
  const [activityList, setActivityList] = useState([
    { label: "Loading...", value: "" },
  ]);
  const [activityValue, setActivityValue] = useState();

  const assignHours = (event) => {
    event.preventDefault();

    // GET request using fetch inside useEffect React hook
    if (userContext.name === "") {
      alert("Not Authorized");
      return;
    }

    fetch(`${baseURL}/api/admin/activity/hours`, {
      method: "POST",
      body: JSON.stringify({
        activity_id: activityIdRef.current.value,
        hours: [
          {
            email_id: emailId.current.value.toLowerCase(),
            hours: hours.current.value,
          },
        ],
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert("Hours Added Successfully.");
          // window.location.reload();
          emailId.current.value = "";
          hours.current.value = "";
          emailId.current.focus();
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
          console.log(res.status);
        }
      })
      .catch((err) => {
        alert("POST Request Failed, Please try again later");
        console.log(err);
      });
  };

  useEffect(() => {
    let unmounted = false;
    async function getActivities() {
      try {
        const response = await fetch(`${baseURL}/api/activity`);
        const body = await response.json();
        if (!unmounted) {
          // console.log("Pls work");
          const activityListTemp = body.activities.map((activity) => ({
            label: `${activity.activity_id}: ${activity.display_name}`,
            value: activity.activity_id,
          }));
          activityListTemp.sort((obj1, obj2) =>
            obj1.value < obj2.value ? 1 : -1
          );

          setActivityList(activityListTemp);
          // console.log(body.activities);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    }

    getActivities();
    return () => {
      unmounted = true;
    };
  }, [baseURL, userContext]);

  return (
    <>
      <MDBContainer style={{ marginBottom: "1.5rem" }} fluid>
        <MDBRow center>
          <MDBCol md="6">
            <form onSubmit={assignHours}>
              <p className="h2 text-center mb-4">Update Hours</p>
              <label htmlFor="activityID" className="black-text">
                Activity Id
              </label>
              <div>
                <select
                  className="browser-default custom-select"
                  id="activityID"
                  disabled={loading}
                  value={activityValue}
                  onChange={(e) => setActivityValue(e.currentTarget.value)}
                  ref={activityIdRef}
                >
                  {activityList.map(({ label, value }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <br />
              <label htmlFor="email" className="black-text">
                Student Email Id
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                ref={emailId}
                required
              />

              <br />
              <label htmlFor="hours" className="black-text">
                Hours
              </label>
              <input
                type="text"
                id="hours"
                className="form-control"
                ref={hours}
                required
              />

              <br />
              <div className="text-center mt-4">
                <MDBBtn color="primary" type="submit">
                  Update
                </MDBBtn>
              </div>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
  );
}

export default UpdateHours;
